( function($) {
	$( '.portal-nav-menu-toggle' ).on( 'click', function(e) {
		e.preventDefault();
		
		$( this ).closest( '.portal-side-menu-container' ).toggleClass( 'menu-closed' );
	} );

	$( '.mobile-portal-nav-menu-toggle' ).on( 'click', function(e) {
		e.preventDefault();
		
		$( this ).find( '.fa-bars' ).toggleClass( 'uk-hidden' );
		$( this ).find( '.fa-close' ).toggleClass( 'uk-hidden' );
	} );
} )( jQuery );
